import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Error } from '../pages/Error';

const errorMessages = {
  title: 'アクセスしようとしたページを表示できませんでした',
  japanese:
    '大変申し訳ございません、ただ今つながりにくくなっております。<br/>今しばらくお待ち頂き、再度アクセスしてください。',
  english:
    'The site is currently experiencing a high volume of traffic.<br/> Please try again later. We are sorry for the inconvenience.',
};

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Error
          title={errorMessages.title}
          japanese={errorMessages.japanese}
          english={errorMessages.english}
        />
      );
    }
    return this.props.children;
  }
}
